"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "moscufo": {
    "9cda7cb6": [{
      "hkey": "b9a8567d",
      "slug": "bivio-casone",
      "name": "Bivio Casone",
      "primary": true,
      "skipSearch": false
    }],
    "bivio": [{
      "hkey": "b9a8567d",
      "slug": "bivio-casone",
      "name": "Bivio Casone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5127ccd1": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "skipSearch": false
    }],
    "casale-cerri": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e2468a6": [{
      "hkey": "b9a8567d",
      "slug": "bivio-casone",
      "name": "Bivio Casone",
      "primary": true,
      "skipSearch": false
    }],
    "casone": [{
      "hkey": "b9a8567d",
      "slug": "bivio-casone",
      "name": "Bivio Casone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "moscufo"
    }],
    "42fef4ed": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "skipSearch": false
    }],
    "colle-sant-angelo": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3a833bf": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ae4e8d4": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "skipSearch": false
    }],
    "tavolaro": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "99487958": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "skipSearch": false
    }],
    "villa-sibi": [{
      "hkey": "a523436e",
      "slug": "moscufo",
      "name": "Moscufo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;